import { defineAction } from '~/prix'
import { z } from 'zod'
import creditEconomicMovementFetchAction from './creditEconomicMovementFetch.action.json' with { type: 'json' }
import { creditEconomicMovementObject } from '../creditEconomicMovementObject'

const creditEconomicMovementFetchDefinition = defineAction({
  ...creditEconomicMovementFetchAction,

  input: z.object({
    id: creditEconomicMovementObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: creditEconomicMovementObject,
})

export default creditEconomicMovementFetchDefinition

